import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  children,
  onClick,
  variant = 'primary',
  size = 'medium',
  className = '',
  disabled = false,
  type = 'button',
  icon = null,
  rounded = false,
  ...props
}) => {
  const baseClasses =
    'font-semibold transition-all duration-300 transform hover:-translate-y-0.5 flex items-center justify-center';

  const variants = {
    gold: 'bg-[#D4AF37] text-black hover:bg-[#B8941F]',
    'gold-outline':
      'bg-transparent border-solid border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black',
    primary:
      'bg-[#2a62aa] text-white border border-[#2a62aa] hover:bg-[#1d4e8a] disabled:bg-gray-400',
    secondary:
      'bg-white text-[#1d263e] border border-[#1d263e] hover:bg-gray-100 disabled:bg-gray-100',
    ghost: 'bg-[#f3f8ff] text-[#002d72] hover:bg-[#e3f0ff] disabled:text-gray-400',
    outline:
      'bg-transparent text-[#2a62aa] border border-[#2a62aa] hover:bg-gray-50 disabled:border-gray-200',
    white: 'bg-[#f3f8ff] text-[#002d72] hover:bg-[#e3f0ff] border border-[#f3f8ff]',
  };

  const sizes = {
    small: 'px-3 py-1 text-sm',
    medium: 'px-4 py-2 text-base',
    large: 'px-6 py-3 text-lg',
    pill: 'px-5 py-2 text-base',
  };

  const buttonClasses = `
    ${baseClasses} 
    ${variants[variant]} 
    ${sizes[size]} 
    ${rounded ? 'rounded-[0.5rem]' : 'rounded-[0.5rem]'}
    ${className} 
    ${disabled ? 'cursor-not-allowed' : ''}
  `
    .trim()
    .replace(/\s+/g, ' ');

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={buttonClasses} {...props}>
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'ghost',
    'outline',
    'white',
    'gold',
    'gold-outline',
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large', 'pill']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  icon: PropTypes.node,
  rounded: PropTypes.bool,
};

export default Button;
